import React, { useEffect, useState } from "react";
import Board from "@asseinfo/react-kanban";
import "@asseinfo/react-kanban/dist/styles.css";
import { Box, Text, Heading, VStack, Input, Checkbox } from "@chakra-ui/react";
import CommonDeleteModel from "../commonDeleteModel";
import ActionNavbar from "../actionBar/ActionNavbar";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import { useNavigate } from "react-router-dom";
import { constant } from "common/constant";
import { priorityLabelMap } from "common/constant";
import colors from "common/theme/foundations/colors";
import { formatedCurrency } from "common/utils/currencyUtils";

const CustomCard = ({
  title,
  closedDate,
  amount,
  priority,
  handleDelete,
  id,
  due,
  moduleData,
  navigationRoute,
  leadEmail,
  companyName,
}) => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const hash = window.location.hash;
  const path = hash.replace("#", "").split("/");
  const pageTitle = path[2] ? path[2].replace(/-/g, " ") : "";
  const handleClick = () => {
    navigate(`${navigationRoute}${id}`, {
      state: { module: moduleData },
    });
  }
  const getPriorityLabel = (priority) => {
    const normalizedPriority = priority.toLowerCase().replace(/\s+/g, '');
    return priorityLabelMap[normalizedPriority] || priority; // Default to priority if not in the map
  };
  return (
    <Box
      className={`react-kanban-card ${isChecked ? "activeKanban" : ""}`}
      p={4}
      bg="white"
      borderRadius="8px"
      boxShadow="sm"
      minW="300px"
      mb={3}
    >
      <Text fontWeight="semibold" onClick={handleClick} cursor="pointer" fontSize="md" mb={2}>
        {title}
      </Text>

      {pageTitle.toLowerCase() === "leads" ? (
        <>
          <Text fontSize={"14px"}> {leadEmail}</Text>
          <Text fontSize={"14px"}>{companyName}</Text>
        </>
      ) : pageTitle.toLowerCase() === "tasks" ? (
        <>
          <Text fontSize={"14px"}> {getPriorityLabel(priority)}</Text>
          <Text fontSize={"14px"}> {due}</Text>
        </>
      ) : (
        <>
          <Text fontSize={"14px"}>{formatedCurrency(amount)}</Text>
          <Text color={colors.red[500]} fontSize={"14px"}>{closedDate}</Text>
        </>
      )
      }

      <Box className="kanban-checkox">
        <Checkbox isChecked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />
      </Box>

      {
        isChecked && (
          <Box className="card-delete-icon" onClick={() => handleDelete(id)} mt={2}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#e00000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-trash-icon lucide-trash"
            >
              <path d="M3 6h18" />
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
            </svg>
          </Box>
        )
      }
    </Box >
  );
};


const NoData = () => (
  <Box className="noDataFound" display={"flex"} justifyContent={"center"}>
    <Text>No Deals Found</Text>
  </Box>
);

const VerticalHeader = ({ title, onUncollapse, cards, bg, pageTitle }) => {
  const totalAmount = cards.reduce((sum, card) => {
    const num =
      parseFloat(card.amount?.toString().replace(/[^0-9.-]+/g, "")) || 0;
    return sum + num;
  }, 0);

  const cardCount = cards.length;

  return <Box className="verticalHeader">
    <Box className="rotatedContent">
      <Box className="dealStage" bg={bg}>{title}</Box>
      <Box className="dealCount">{cardCount}</Box>
      {pageTitle !== "Tasks" && pageTitle !== "Leads" && (
        <Box className="dealAmount">₹ {totalAmount}</Box>
      )}

    </Box>
    <Box className="uncollapseIcon" onClick={onUncollapse} cursor="pointer">
      <img width="24" height="24" src="https://img.icons8.com/ios-filled/24/split-horizontal.png" alt="split-horizontal" />
    </Box>
  </Box>
};

const CustomColumnHeader = ({ title, cards, bg, onCollapse, pageTitle }) => {
  const totalAmount = cards.reduce((sum, card) => {
    const num =
      parseFloat(card.amount?.toString().replace(/[^0-9.-]+/g, "")) || 0;
    return sum + num;
  }, 0);

  const cardCount = cards.length;

  return (
    <Box
      spacing={0}
      align="start"
      mb={2}
      className="react-kanban-column-header"
      bg={bg}
      display={"flex"}
      justifyContent={"space-between"}
      gap={"24px"}
    >
      <Box>
        <Heading fontWeight={"500"} display={"flex"} gap={3} fontSize="16px">
          {title} <Text className="cardCount">{cardCount}</Text>
        </Heading>
        {pageTitle !== "Tasks" && pageTitle !== "Leads" && <Text mt={"4px"} fontSize="sm" color="gray.600">
          ₹ {totalAmount}
        </Text>}
      </Box>
      <Box className="collapseIcon" onClick={onCollapse} cursor="pointer">
        <img
          width="24"
          height="24"
          src="https://img.icons8.com/ios-filled/24/merge-vertical.png"
          alt="merge-vertical"
        />
      </Box>
    </Box>
  );
};

const KanbanView = ({
  access,
  selectedValues,
  setIsImport,
  ManageGrid,
  handleTabChange,
  listViewHandle,
  kanbanViewHandle,
  currentView,
  kanbanData,
  headerOptions,
  kanbanCardUpdateHandler,
  moduleData,
  title = "",
  navigationRoute = "",
  finalSearchedData,
  setFinalSearchedData,


  // props for search
  setSearchedDataOut,
  setSearchboxOutside,
  searchboxOutside,
  dataColumn,
  AdvanceSearch,
  searchDisplay,
  setSearchDisplay,
  setGetTagValuesOutside,
  state,
  tableCustomFields,
  searchedDataOut,
  source = '',
  handleSearchChange,
  searchbox,
  setSearchbox,
 onOpen = () => {},
}) => {
  const [boardData, setBoardData] = useState([]);
  const [selectedCardToDelete, setSelectedCardToDelete] = useState(null);
  const [collapsedColumns, setCollapsedColumns] = useState({});




  const toggleCollapse = (columnId) => {
    setCollapsedColumns((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };

  useEffect(() => {
    if (!Array.isArray(headerOptions) || !finalSearchedData) return;
    const boardHeader = headerOptions[0]?.options ?? [];



    const formattedKanban = boardHeader.map((stage, index) => ({
      id: index + 1,
      title: stage.name,
      bg: `${stage.color}1f`,
      cards: [],
    }));

    finalSearchedData?.forEach((item) => {
      const stageValue =
        item.stage || item.leadStatus || item.status || "";

      const stageIndex = boardHeader.findIndex(
        (stage) =>
          stage.name?.replace(/\s+/g, "")?.toLowerCase() ===
          stageValue?.replace(/\s+/g, "")?.toLowerCase()
      );

      if (stageIndex !== -1) {
        if (title === "Leads") {
          formattedKanban[stageIndex].cards.push({
            id: item?._id,
            title: item?.leadName || "",
            stage: stageValue,
            leadEmail: item?.leadEmail || "",
            leadStatus: item?.leadStatus || "",
            companyName: item?.companyName || "",
          });
        } else if (title === "Tasks") {
          formattedKanban[stageIndex].cards.push({
            id: item?._id,
            title: item?.title || "",
            stage: stageValue,
            priority: item?.priority || "Not Defined",
            status: item?.status || "",
            due: item?.end || ""
          });
        } else {
          formattedKanban[stageIndex].cards.push({
            id: item?._id,
            title: item?.dealName || "",
            stage: stageValue,
            closedDate: item?.closeDate,
            amount: Number(item?.amount || item?.annualRevenue) || 0,
          });
        }
      }
    });

    setBoardData(formattedKanban);

  }, [headerOptions, finalSearchedData]);


  useEffect(() => {
    document.body.classList.add("noBackground");
    return () => {
      document.body.classList.remove("noBackground");
    };
  }, []);

  const [deleteModel, setDelete] = useState(false);
  const navigate = useNavigate();

  const handleDelete = (id) => {
    setSelectedCardToDelete(id);
    setDelete(true);
  };

  const cardDeleteHandler = async () => {
    const success = await kanbanCardUpdateHandler("delete", selectedCardToDelete);

    if (success) {
      setFinalSearchedData((prev) =>
        prev.filter((item) => item._id !== selectedCardToDelete)
      );
      setDelete(false);
    } else {
      console.error("Failed to delete card");
    }
  };


  function closeDeleteModal() {
    setDelete(false);
  }

  const filterSelectOptions = constant.filterSelectList.map((item) => ({
    ...item,
    label: item.label.replace("title", title),
  }));
  const actionSelectOptions = constant.actionSelectList.map((item) => ({
    ...item,
    label: item.label.replace("title", title),
  }));

  const handleFilterSelect = (selectedOption) => {
    console.log("filterSelected", selectedOption);
  };

  const handleActionSelect = (option) => {
    console.log("Selected Action Option:", option);
  };

  const cardDragEndHandler = (card, fromColumn, toColumn) => {
    const updatedBoard = [...boardData];

    const sourceIndex = fromColumn.fromColumnId - 1;
    const destIndex = toColumn.toColumnId - 1;

    const cardIndex = updatedBoard[sourceIndex].cards.findIndex(
      (c) => c.id === card.id
    );

    if (cardIndex === -1) return;

    const [movedCard] = updatedBoard[sourceIndex].cards.splice(cardIndex, 1);
    updatedBoard[destIndex].cards.splice(toColumn.toPosition, 0, movedCard);
    movedCard.stage = updatedBoard[destIndex].title;

    setBoardData(updatedBoard);

    kanbanCardUpdateHandler("update", movedCard);
  };

  const handleClick = () => {
    onOpen();
  };

  // useEffect(() => {
  //   console.log("Search results updated in KanbanView:", searchedDataOut)
  // }, [searchedDataOut])

  return (
    <>
      <ActionNavbar
        title={singularizeLastWord(title)}
        onCreateClickHandler={handleClick}
        isCreateBtnVisible={access?.create || access === true}
        selectedValues={selectedValues}
        //   handleExportLeads={handleExportLeads}
        //   setManageColumns={setManageColumns}
        setIsImport={setIsImport}
        ManageGrid={ManageGrid}
        handleTabChange={handleTabChange}
        filterSelectOption={filterSelectOptions}
        onFilterSelect={handleFilterSelect}
        actionOptions={actionSelectOptions}
        handleActionSelect={handleActionSelect}
        listViewHandle={listViewHandle}
        kanbanViewHandle={kanbanViewHandle}
        currentView={currentView}




        setSearchedDataOut={setSearchedDataOut}
        setSearchboxOutside={setSearchboxOutside}
        searchboxOutside={searchboxOutside}
        allData={kanbanData}
        dataColumn={dataColumn}
        AdvanceSearch={AdvanceSearch}
        searchDisplay={searchDisplay}
        setSearchDisplay={setSearchDisplay}
        setGetTagValuesOutside={setGetTagValuesOutside}
        state={state}
        tableCustomFields={tableCustomFields}
        searchedDataOut={searchedDataOut}
        tableData={kanbanData}

        setFinalSearchedData={setFinalSearchedData}

        isKanban={true}
        source={source}
        handleSearchChange={handleSearchChange}
        searchbox={searchbox}
        setSearchbox={setSearchbox}

      />
      <Box className="CustomKanban" mt={"45px"}>
        <Board
          disableColumnDrag
          onCardDragEnd={(card, fromColumn, toColumn) => {
            cardDragEndHandler(card, fromColumn, toColumn);
          }}
          renderCard={(card) => <CustomCard handleDelete={handleDelete} moduleData={moduleData} {...card} navigationRoute={navigationRoute} />}
          renderColumnHeader={(column) => {
            const isCollapsed = collapsedColumns[column.id];
            return isCollapsed ? (
              <VerticalHeader
                title={column.title}
                cards={column.cards}
                bg={column.bg}
                onUncollapse={() => toggleCollapse(column.id)}
                pageTitle={title}
              />
            ) : (
              <CustomColumnHeader
                title={column.title}
                cards={column.cards}
                bg={column.bg}
                onCollapse={() => toggleCollapse(column.id)}
                pageTitle={title}
              />
            );
          }}
        >
          {{
            columns: boardData,
          }}
        </Board>
      </Box>
      <CommonDeleteModel
        isOpen={deleteModel}
        onClose={() => closeDeleteModal()}
        handleDeleteData={cardDeleteHandler}
        type={singularizeLastWord(title)
        }
        ids={""}
      />
    </>
  );
};

export default KanbanView;
